module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/pic4-fb5390a74deb148954fe86c9cde74c46.png";